module.exports = {"publicPath":"/centraldoservidor/","apiUrl":"https://egov.santos.sp.gov.br/centralservidor-api/","apiEnderecoUrl":"https://egov.santos.sp.gov.br/endereco/api/v1/","staticUrl":"https://egov.santos.sp.gov.br/centraldoservidor/static/"}


//////////////////
// WEBPACK FOOTER
// ./env.json
// module id = ufme
// module chunks = 5